import React from 'react'

import { Spacer } from '@zet/common/components/loader/spacer'
import { Stack, XStack } from '@zet/design-system'
import { MotiView } from 'moti'
import { Skeleton } from 'moti/skeleton'

const LeadCardSkeleton = () => {
  return (
    <MotiView
      transition={{
        type: 'timing',
      }}
      animate={{ backgroundColor: '#ffffff' }}
      className="mt-3 bg-white px-3"
    >
      <XStack className="items-center">
        <Stack className="mr-2">
          <Skeleton
            radius={'square'}
            height={48}
            colorMode={'light'}
            width={48}
          />
        </Stack>
        <Spacer />
        <Stack>
          <Skeleton height={15} colorMode={'light'} width={'60%'} />
          <Spacer />
          <Skeleton height={15} colorMode={'light'} width={'60%'} />
        </Stack>
      </XStack>
      <Spacer />
      <Skeleton height={20} colorMode={'light'} width={'100%'} />
      <Spacer />
      <Skeleton height={20} colorMode={'light'} width={'100%'} />
    </MotiView>
  )
}

export default LeadCardSkeleton
